import {Component} from '@angular/core';
import {PrimeNgImportsModule} from '../../../../../sdk/src/prime-ng-imports';
import {UserRoleCRUDComponent} from '../../../components/user-role-crud/user-role-crud.component';
import {IBasePageComponent} from '../../../../../sdk/src/components/ibase-page/ibase-page.component';

@Component({
    selector: 'app-ga-user-roles-page',
    templateUrl: './user-roles-page.component.html',
    imports: [PrimeNgImportsModule, UserRoleCRUDComponent]
})
export class GUserRolesPage extends IBasePageComponent {
    /**
     * On ready (Error handling and refresh is done in the parent)
     */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    protected override async onReady(): Promise<void> {}
    /**
     * On destroy (Error handling and refresh is done in the parent)
     */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    protected override async onDestroy(): Promise<void> {}
}
